import React, { useEffect } from 'react';
import "./fileinfo.css";
import { AvatarGroup } from "@material-ui/lab";
import { Avatar } from "@material-ui/core";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import DummyProfile from "../../../../static/Linkedlnposter.png";
import { useHistory } from 'react-router-dom';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import {
    deleteFile, fetchAllProjects, duplicateFile,
    moveFile, renameFile
} from '../../../../actions/projectActions';
import { useDispatch, useSelector } from 'react-redux';
import { Button, CircularProgress } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

const FileInfo = ({ name, fileData }) => {
    // var Today = new Date();
    const dispatch = useDispatch();
    const history = useHistory();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [anchorEl2, setAnchorEl2] = React.useState(null);
    const [open, setOpen] = React.useState(false);
    const [acionType, setActionType] = React.useState("rename");
    const [newName, setNewName] = React.useState(name);
    const [folderName, setfolderName] = React.useState("");

    const currentWorkSpace = useSelector(state => state.currentWorkSpace);
    const { currentWorkspaceDetails } = currentWorkSpace;

    const allProjects = useSelector(state => state.allProjects);
    const { projectDetails } = allProjects;

    const fileRename = useSelector(state => state.fileRename);
    const { loading: loadingRename, renameFileInfo } = fileRename;

    const fileDuplicate = useSelector(state => state.fileDuplicate);
    const { duplicateFileInfo } = fileDuplicate;

    const fileMove = useSelector(state => state.fileMove);
    const { moveFileInfo } = fileMove;

    useEffect(() => {
        if (renameFileInfo) {
            handleDialogClose();
        }
        if (duplicateFileInfo || moveFileInfo) {
            handleCloseTwo();
        }
    }, [renameFileInfo, duplicateFileInfo, moveFileInfo])

    useEffect(() => {
        if (projectDetails) {
            let newArr = projectDetails.filter(val => val._id === fileData.Folder);
            setfolderName(newArr[0]?.name);
        }
    }, [projectDetails])

    const handleClickOpen = () => {
        setOpen(true);
        handleClose();
    };

    const handleDialogClose = () => {
        setOpen(false);
        handleClose();
    };

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClickTwo = (event) => {
        setAnchorEl2(event.currentTarget);
        handleClose();
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleCloseTwo = () => {
        setAnchorEl2(null);
    };

    useEffect(async () => {
        if (currentWorkspaceDetails) {
            dispatch(fetchAllProjects(currentWorkspaceDetails._id));
        }
    }, [currentWorkspaceDetails, dispatch]);

    const handleRedirect = () => {
        if (fileData.type === 'TAGLINE') {
            history.push({
                pathname: `/generate/file/taglines/${fileData._id}`,
                state: fileData,
                key: fileData._id,
            });
        }
        if (fileData.type === 'LINKEDIN_ADD') {
            history.push({
                pathname: `/generate/file/linkedlnAd/${fileData._id}`,
                state: fileData,
                key: fileData._id,
            });
        }
        if (fileData.type === 'GOOGLE_ADD') {
            history.push({
                pathname: `/generate/file/googleAd/${fileData._id}`,
                state: fileData,
                key: fileData._id,
            });
            console.log(fileData);
        }
        if (fileData.type === 'amazonDesc') {
            history.push({
                pathname: `/generate/file/amazondesc/${fileData._id}`,
                state: fileData,
                key: fileData._id,
            });
        }

        if (fileData.type === 'BLOG_QUOTE') {
            history.push({
                pathname: `/generate/file/BlogQuote/${fileData._id}`,
                state: fileData,
                key: fileData._id,
            });
        }

        if (fileData.type === 'BLOG_IDEAS') {
            history.push({
                pathname: `/generate/file/BlogIdeas/${fileData._id}`,
                state: fileData,
                key: fileData._id,
            });
        }

        if (fileData.type === 'BLOG_INTRO') {
            history.push({
                pathname: `/generate/file/BlogIntro/${fileData._id}`,
                state: fileData,
                key: fileData._id,
            });
        }

        if (fileData.type === 'FAQ') {
            history.push({
                pathname: `/generate/file/Faq/${fileData._id}`,
                state: fileData,
                key: fileData._id,
            });
        }

        if (fileData.type === 'PAIN_AGITATE_SOLUTION') {
            history.push({
                pathname: `/generate/file/PainAgitate/${fileData._id}`,
                state: fileData,
                key: fileData._id,
            });
        }

        if (fileData.type === 'FACEBOOK_ADD') {
            history.push({
                pathname: `/generate/file/facebookAd/${fileData._id}`,
                state: fileData,
                key: fileData._id,
            });
        }
    }

    const handleDelete = () => {
        dispatch(deleteFile(fileData._id));
        handleClose();
    }

    const handleFolderSelect = (folderId) => {
        if (acionType === 'copy') {
            dispatch(duplicateFile({
                fileId: fileData._id,
                folderId
            }))
        } else {
            dispatch(moveFile({
                fileId: fileData._id,
                folderId
            }))
        }
    }

    const handleRename = () => {
        if (newName) {
            dispatch(renameFile({
                fileId: fileData._id,
                name: newName
            }))
        } else {
            setOpen(false);
        }

    }

    return (
        <div className="recentfiletab" >
            <div className="recentfiletab__header">
                {" "}
                <h3 onClick={handleRedirect}>{name}</h3>
                <MoreHorizIcon className="recentfiletab__option" aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick}>...</MoreHorizIcon>
            </div >
            <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                <MenuItem aria-controls="simple-menu-two" aria-haspopup="true" onClick={(e) => {
                    setActionType("copy");
                    handleClickTwo(e);
                }}>Copy</MenuItem>
                <MenuItem aria-controls="simple-menu-two" aria-haspopup="true" onClick={(e) => {
                    setActionType("move");
                    handleClickTwo(e);
                }}>Move</MenuItem>
                <MenuItem onClick={handleClickOpen}>Rename</MenuItem>
                <MenuItem onClick={handleDelete}>Delete</MenuItem>
            </Menu>
            <Menu
                id="simple-menu-two"
                anchorEl={anchorEl2}
                keepMounted
                open={Boolean(anchorEl2)}
                onClose={handleCloseTwo}
            >
                <MenuItem>Select Folder</MenuItem>
                {projectDetails?.map(item => (
                    <MenuItem key={item._id} onClick={() => {
                        handleFolderSelect(item._id);
                    }}>{item.name}</MenuItem>
                ))}
            </Menu>
            <AvatarGroup max={4}>
                {" "}
                <Avatar src={DummyProfile} />
                <Avatar src={DummyProfile} />
                <Avatar src={DummyProfile} />
                <Avatar src={DummyProfile} />
                <Avatar src={DummyProfile} />
            </AvatarGroup>
            {/* <h4>Folder: {folderName}</h4> */}
            <p className="recentfiletab__date">
                {/* {Today.getDate() +
          "/" +
          (Today.getMonth() + 1) +
          "/" +
          Today.getFullYear()} */}
                {fileData.updated_at?.substr(0, 10)}
            </p>
            <Dialog open={open} onClose={handleDialogClose} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Rename File</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Enter the new name for the file in the below text field
                    </DialogContentText>
                    <TextField
                        autoFocus
                        margin="dense"
                        value={newName}
                        onChange={e => setNewName(e.target.value)}
                        id="name"
                        label="New File Name"
                        type="text"
                        fullWidth
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDialogClose} color="primary">
                        Cancel
                    </Button>
                    {loadingRename ? <CircularProgress /> : (
                        <Button onClick={handleRename} color="primary">
                            Rename
                        </Button>
                    )}
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default FileInfo
